module.exports = __webpack_public_path__ + "img/member06.fc4867e2.png";